<template>
  <span
    class="description-element"
    :class="{ active: this.etat }"
    :data-index="codeIndex"
    @click="handleClickDescription(codeIndex)"
  >
    <font-awesome-icon :icon="['fas', 'file-alt']" />
  </span>
</template>

<script>
import { EventBus, events } from '../../eventBus'
export default {
  props: {
    codeIndex: Number,
    contenu: String,
    etat: Boolean
  },
  methods: {
    handleClickDescription (codeIndex) {
      EventBus.$emit(events.ON_DESCRIPTION_OPEN, codeIndex, this.contenu)
    }
  }
}
</script>

<style lang="scss">
.description-element {
  svg {
    color: #dedede;
  }
  &.active {
    svg {
      color: #f9b11c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tableau/descriptionComponent.vue